var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeftMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72882 12.731C7.43094 12.4432 7.42279 11.9684 7.71061 11.6705C7.71906 11.6618 7.72768 11.6533 7.73645 11.645L15.2276 4.40029C15.5254 4.11234 16.0002 4.12028 16.2881 4.41803C16.5761 4.71578 16.5682 5.19058 16.2704 5.47854L9.40348 12.1195C9.36282 12.1589 9.36284 12.224 9.40351 12.2633L16.2702 18.8981C16.568 19.186 16.5762 19.6608 16.2884 19.9586C16.0005 20.2565 15.5257 20.2647 15.2279 19.9769L7.7354 12.7374",
    fill: "#484B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftMedium);
export default __webpack_public_path__ + "static/media/chevron-left-medium.c83bebdcf02a40d8e852e6ed522a7510.svg";
export { ForwardRef as ReactComponent };